import { render, staticRenderFns } from "./JobQuery.vue?vue&type=template&id=764bef63&scoped=true&"
import script from "./JobQuery.vue?vue&type=script&lang=js&"
export * from "./JobQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764bef63",
  null
  
)

export default component.exports